<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-col :span="1"></a-col>
    <a-col class="justify-content-center" :span="22">
      <div style="margin-top: 28px"></div>
      <div class="card-header pb-0 col-sm-12 d-flex">
        <div class="col-sm-12 col-xs-12">
          <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
            <h3 class="title">{{ $t('navbar_salesrecord_list') }}</h3>
            <h5 class="desc">ERP 매출실적을 조회 할 수 있습니다.</h5>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2 table-with-search">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              검색어
            </div>
            <div class="search-filter-content">
              <div class="mobile-wrap">
                <a-select
                  size="small"
                  style="width: 150px"
                  v-model:value="searchFilter.keyword.option"
                  @change="v => searchFilter.keyword.option = v"
                >
                  <a-select-option value="품목명">
                    품목명
                  </a-select-option>
                  <a-select-option value="거래처명">
                    거래처명
                  </a-select-option>
                  <a-select-option value="영업사원">
                    영업사원
                  </a-select-option>
                </a-select>
                <!-- <div class="search-input-container">
                  <div class="search-icon">
                    <i class="fa-regular fa-magnifying-glass"/>
                  </div>
                  <input
                      type="text"
                      class="search-input-text"
                      v-model="searchFilter.keyword.word"
                      @keyup.enter="async (event) => {
                        paginationData.currentPage = 1
                        await uiHandler.search();
                      }"
                      @focusin="e => searchFilter.keyword.word = ''"
                      placeholder="검색어를 입력하세요"
                  />
                </div> -->
                <a-input 
                    size="small"
                    v-model:value="searchFilter.keyword.word"
                    @keyup.enter="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search();
                    }"
                    @focusin="e => searchFilter.keyword.word = ''"
                    :placeholder="$t('common_searchfilter_placeholder')"
                >
                  <template #prefix>
                    <i
                        class="fa-regular fa-magnifying-glass"
                    />
                  </template>
                </a-input>
              </div>
              <div class="mobile-wrap">
                <button
                    class="search-btn-filter"
                    @click="async (event) => {
                      paginationData.currentPage = 1
                      await uiHandler.search()
                    }"
                >
                  검색
                </button>
                <button
                    class="init-btn"
                    @click="event => {
                      searchFilter.keyword.option = '품목명'
                      searchFilter.keyword.word = ''
                      searchFilter.deptName = ''
                      dateRanges = []
                      searchFilter.salesStartDate = ''
                      searchFilter.salesEndDate = ''
                      paginationData.currentPage = 1
                      searchFilter.selectedDateFilter = 'all'
                      uiHandler.search()
                    }"
                >
                  초기화
                </button>
              </div>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              매출일
            </div>
            <div class="search-filter-content">
              <div class="date-filter-container-wrapper is-mobile-only">
                <div class="date-filter-container ">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFilters.slice(0,1)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container ">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(1,3)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
                <div class="date-filter-container  " style="width: 100%;">
                  <div
                      v-for="item in searchFilter.dateFilters.slice(3,4)"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      style="width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                      @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>
              </div>
              <div class="date-filter-container is-desktop-tablet">
                <div
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = 'all'
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{ $t('common_total') }}
                </div>
                <div
                    v-for="item in searchFilter.dateFilters"
                    class="date-filter-item"
                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                    @click="async (e) => {
                        searchFilter.selectedDateFilter = item
                        paginationData.currentPage = 1
                        await uiHandler.search()
                      }"
                >
                  {{
                    item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                  }}
                </div>
              </div>

              <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                <a-range-picker 
                  size="small"
                  :allowClear="false" :locale="locale" v-model:value="dateRanges"
                  @change="async (e) => {
                    searchFilter.selectedDateFilter = 'etc'
                    paginationData.currentPage = 1
                    await uiHandler.search()
                  }"
                  style="width: 250px;"/>
              </div>
            </div>
          </div>

          <div class="search-filter-row" v-if="isDentiumAdmin">
            <div class="search-filter-title">
              지점
            </div>
            <div class="search-filter-content">
              <a-select show-search
                        style="width: 150px; min-width: 100px"
                        size="small"
                        v-model:value="searchFilter.deptName"
                        :notFoundContent="null"
                        @change="async (e) => {
                          paginationData.currentPage = 1
                          await uiHandler.search()
                        }"
                        :options="deptNames"></a-select>

            </div>
          </div>
        </div>
        <div class="col-xs-12 table-info-filter">
          <div class="total-div">
            <p>
              {{ $t('common_total') }}
              <span class="number-highlight">{{ formatCommaNumber(salesRecord.totalDocs) }}</span>
              {{ $t('common_case') }}
            </p>
          </div>
          <div class="search-container">
            <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                      @change="uiHandler.search">
              <a-select-option :value="10" selected>10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
          <div class="table-responsive table-wrap">
            <a-table class="ant-table-striped"
                     bordered
                     size="small"
                     :columns="salesRecord.columns"
                     :data-source="salesRecord.list"
                     :pagination="false"
                     v-if="salesRecord.list.length > 0"
            >
            </a-table>
            <div class="no-result-container" v-else>
                <i class="fa-solid fa-exclamation-triangle" />
                <span>{{ computedNoResultMessage }} </span>
            </div>
          </div>
        </div>
      </div>
      <pagination
          v-if="!noResult"
          :page-info="paginationData"
          page-name="SalesRecordList"
          @change-page="async (childPassParam) => {
            paginationData.currentPage = childPassParam.page;
            await uiHandler.search()
          }"
      />
    </a-col>
    <a-col :span="1"></a-col>
  </a-row>
</template>
<script>
import { getProfile } from '@/utils/tokenStore';
import { masterCheckUsername } from '@/utils/supportMaster';
import salesRecordApi from "@/views/SalesRecordManagement/api";
import Pagination from "@/views/components/Pagination.vue";
import NoResult from "@/views/components/NoResult.vue";
import {dateUtils, formatCommaNumber, logging, oneBtnDialog} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";

export default {
  components: {
    Pagination,
    NoResult
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_salesrecord');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
    noResult() {
      return !this.$store.state.isLoading && this.salesRecord.totalDocs === 0
    },
    // 마스터 비교용 아이디 — 지원 탭이면 그 회사 최상위 관리자(utils/supportMaster)
    checkUsername() {
      return masterCheckUsername(this.companyInfo?.accountInfo?.username, this.$store.state.privileges)
    },
    isDentiumEquip() {
      return this.checkUsername === 'dentium03'
    },
    isDentiumAdmin() {
      return this.checkUsername === 'dentium'
    }
  },
  data() {
    return {
      locale,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      formatCommaNumber,
      dateUtil: dateUtils(),
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      deptNames: [],
      dateRanges: [dayjs().startOf('month'), dayjs()],
      searchFilter: {
        keyword: {
          option: '품목명',
          word: ''
        },
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 'etc'],
        deptName: '',
        salesStartDate: '',
        salesEndDate: ''
      },
      calledApiTimes: 0,
      salesRecord: {
        totalDocs: 0,
        list: [],
        columns: [
          {key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: 40},
          {
            key: 'salesDate', dataIndex: 'salesDate', title: '매출일', align: 'center',
            customRender: ({text}) => {
              return (
                  <a-typography-text>{dayjs(text).format("YYYY/MM/DD")}</a-typography-text>
              )
            }
          },
          {key: 'CustName', title: '거래처명', dataIndex: 'CustName', align: 'center'},
          {key: 'deptName', title: '부서/지점', dataIndex: 'deptName', align: 'center'},
          {key: 'EmpName', title: '영업사원', dataIndex: 'EmpName', align: 'center'},
          {key: 'ItemName', title: '품목명', dataIndex: 'ItemName', align: 'center'},
          // {key: 'Spec', title: '스펙', dataIndex: 'Spec', align: 'center'},
          {
            key: 'Price', title: '가격', dataIndex: 'Price', align: 'center',
            customRender: ({text, record}) => {
              const price = record?.Price?.toLocaleString();
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{price}원</a-typography-text>
                  </div>
              )
            }
          },
          {
            key: 'Qty', title: '수량', dataIndex: 'Qty', align: 'center',
            customRender: ({text, record}) => {
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{text}</a-typography-text>
                  </div>
              )
            }
          },
          {
            key: 'totalAmount', title: '매출총액', dataIndex: 'totalAmount', align: 'center',
            customRender: ({text, record}) => {
              const amount = record?.totalAmount?.toLocaleString();
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{amount}원</a-typography-text>
                  </div>
              )
            }
          },
          {
            key: 'SalesAmt', title: '매출액', dataIndex: 'SalesAmt', align: 'center',
            customRender: ({text, record}) => {
              const amount = record?.SalesAmt?.toLocaleString();
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{amount}원</a-typography-text>
                  </div>
              )
            }
          },
          {
            key: 'SalesVat', title: '부가세', dataIndex: 'SalesVat', align: 'center',
            customRender: ({text, record}) => {
              const amount = record?.SalesVat?.toLocaleString();
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{amount}원</a-typography-text>
                  </div>
              )
            }
          },
          {
            key: 'Remark', title: '비고', dataIndex: 'Remark', align: 'center',
            customRender: ({text, record}) => {
              if (text) {
                return <span>{text}</span>
              } else {
                return <span>-</span>
              }
            }
          },
        ]
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
    }
  },
  async mounted() {
    const monthDateQueryParamValue = this.$route.query.monthDate;
    if (monthDateQueryParamValue) {
      this.searchFilter.selectedDateFilterForContractDate = 'etc';
      let startOfMonth = dayjs().month(monthDateQueryParamValue - 1).startOf('month').format('YYYYMMDD');
      let endOfMonth = dayjs().month(monthDateQueryParamValue - 1).endOf('month').format('YYYYMMDD');
      this.searchFilter.salesStartDate = startOfMonth
      this.searchFilter.salesEndDate = endOfMonth
    }

    const dayDateQueryParamValue = this.$route.query.dayDate;
    if (dayDateQueryParamValue) {
      this.searchFilter.selectedDateFilterForContractDate = 'etc';
      this.searchFilter.salesStartDate = dayjs(dayDateQueryParamValue).format("YYYYMMDD")
      this.searchFilter.salesEndDate = dayjs(dayDateQueryParamValue).format("YYYYMMDD")
    }

    const branchQueryParamValue = this.$route.query.branch;
    if (branchQueryParamValue) {
      this.searchFilter.deptName = branchQueryParamValue
    }
    await this.uiHandler.init();
  },
  methods: {
    ui() {
      return {
        init: async () => {
          await this.uiHandler.loadDeptNames();
          await this.uiHandler.search();
        },
        loadDeptNames: async () => {
          await this.apiHandler.getDistinctDeptName({}, (deptNames) => {
            this.deptNames = deptNames;
          }, (error) => {
            console.error('Failed to load department names', error);
          });
        },
        convertMonthAndYearText: (input) => {
          if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
          return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
        },
        search: async () => {
          const params = {
            page: this.paginationData.currentPage,
            limit: this.paginationData.rowsPerPage
          }
          if (this.searchFilter.keyword.word) {
            if (this.searchFilter.keyword.option === '품목명') {
              params['itemName'] = this.searchFilter.keyword.word
            }
            if (this.searchFilter.keyword.option === '거래처명') {
              params['custName'] = this.searchFilter.keyword.word
            }
            if (this.searchFilter.keyword.option === '영업사원') {
              params['empName'] = this.searchFilter.keyword.word
            }
          }
          if (this.searchFilter.selectedDateFilter === 'all') {
            params["startSalesDate"] = '20230101'
            params["endSalesDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 3) {
            params["startSalesDate"] = dayjs().subtract(3, 'month').format('YYYYMMDD')
            params["endSalesDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 12) {
            params["startSalesDate"] = dayjs().subtract(12, 'month').format('YYYYMMDD')
            params["endSalesDate"] = dayjs().format('YYYYMMDD')
          }
          if (this.searchFilter.selectedDateFilter === 'etc') {
            params["startSalesDate"] = dayjs(this.dateRanges[0]?.valueOf()).format('YYYYMMDD')
            params["endSalesDate"] = dayjs(this.dateRanges[1]?.valueOf()).format('YYYYMMDD')
          }
          if (this.searchFilter.salesStartDate && this.searchFilter.salesEndDate) {
            params["startSalesDate"] = this.searchFilter.salesStartDate
            params["endSalesDate"] = this.searchFilter.salesEndDate
          }
          if (this.searchFilter.deptName) {
            params['deptName'] = this.searchFilter.deptName
          }

          await this.apiHandler.getSalesRecords(params, (response) => {
            this.calledApiTimes ++;
            this.paginationData.totalPages = response.data.totalPages;
            this.salesRecord.list = response.data.docs;
            this.salesRecord.totalDocs = response.data.totalDocs;
            for (let i = 0; i < this.salesRecord.list.length; i++) {
              const item = this.salesRecord.list[i];
              item.index = this.salesRecord.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
            }
            console.log('123',this.salesRecord.length)
          }, (error) => {
            logging().exceptProd('getSaleRecords fail==>', error)
            oneBtnDialog('목록 로드 오류', '매출 목록 로드에 실패했습니다.', false);
          })
        }
      }
    },
    api() {
      return salesRecordApi(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped>
.ant-btn-default:hover {
  color: #2F3337 !important;
}

.noData {
  color: #acb2b9;
  font-size: 16px;
  margin: 20px;
}

.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.extra-btn-wrap {
  display: flex;
  gap: 16px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range{
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .date-filter-container {
      flex-direction: row;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        width: 50%;
        border-bottom: 0;
      }
    }
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-right: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}
</style>